import * as EventConstants from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';

const SidebarActions = {};

SidebarActions.open = function () {
  AppDispatcher.dispatch({
    actionType: EventConstants.SIDEBAR_OPEN,
  });
};

SidebarActions.openSection = function (section) {
  AppDispatcher.dispatch({
    actionType: EventConstants.SIDEBAR_OPEN,
    section,
  });
};

/**
 * An action to be called whenever a new file is being rendered into the buffers that signals to the
 * SideBar to render the appropriate section.
 *
 * @param  {String} fileType The fileType of the to-be-opened files (i.e., from ModelTypeConstants)
 */
SidebarActions.openSectionForFileType = function (fileType) {
  AppDispatcher.dispatch({
    actionType: EventConstants.SIDEBAR_OPEN_FOR_FILE_TYPE,
    fileType,
  });
};

SidebarActions.close = function () {
  AppDispatcher.dispatch({
    actionType: EventConstants.SIDEBAR_CLOSE,
  });
};

export default SidebarActions;
